import { Inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class GtmService {

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public loadGtm(): void {
    const gtmId = environment.gtmId;
    const gtmAuth= environment.gtm_auth;
    const gtm_preview = environment.gtm_preview;

    const scriptTag = this.document.createElement('script');
    scriptTag.innerHTML = `
      (function(w,d,s,l,i,o,k){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&gtm_auth='+o+'&gtm_preview='+k+'&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}','${gtmAuth}','${gtm_preview}');
    `;
    this.document.head.appendChild(scriptTag);
    const iframe = this.document.getElementById('gtm-frame') as HTMLIFrameElement;
    if (iframe) {
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}&gtm_auth=${gtmAuth}&gtm_preview=${gtm_preview}&gtm_cookies_win=x`;
    }
  }
}
